export const ApartmentMenu = [
    { name: "Dashboard", icon: "clarity:home-solid", url: "/apartment/dashbaord" },
    { name: "T&C", icon: "iconoir:notes", url: "/apartment/termsandcondition" },
    { name: "Contact Person History", icon: "iconoir:notes", url: "/apartment/accounthistory" },
    { name: "Assign Facility", icon: "iconoir:notes", url: "/apartment/assignfacility" },
    { name: "Moment & Attendance", icon: "iconoir:notes", url: "/apartment/momentandattendance" },

    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" }
];

export const StudentMenu = [
    { name: "Dashboard", icon: "clarity:home-solid", url: "/student/dashboard" },
    { name: "My Courses", icon: "hugeicons:course", url: "/student/courses" },
    { name: "My Events", icon: "hugeicons:course", url: "/student/events" },
    { name: "Moments", icon: "solar:hamburger-menu-broken", url: "/student/moments" },
    { name: "Explore", icon: "material-symbols-light:travel-explore-rounded", url: "/student/explore" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/student/raisedticket" },
    { name: "Order History", icon: "material-symbols-light:deployed-code-history-outline", url: "/student/orderhistory" },
    // { name: "Piggy Bank", icon: "fluent:money-20-regular", url: "/student/piggybank" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" }
];

export const TrainerMenu = [
    { name: "Dashboard", icon: "clarity:home-solid", url: "/trainer/dashbaord" },
    // { name: "Schedules", icon: "icon-park-outline:category-management", url: "/trainer/schedules" },
    { name: "Students Attendance  List", icon: "lsicon:order-outline", url: "/trainer/studentslist" },
    // { name: "Students Courses", icon: "hugeicons:course", url: "/trainer/studentscourses" },
    { name: "My Courses", icon: "lsicon:order-outline", url: "/trainer/mycourses" },
    { name: "Moments", icon: "solar:hamburger-menu-broken", url: "/trainer/moments" },
    { name: "Attendance List", icon: "solar:hamburger-menu-broken", url: "/trainer/attendancelist" },
    { name: "Student Enquiry", icon: "solar:hamburger-menu-broken", url: "/trainer/studentenquiry" },
    { name: "Register Student", icon: "solar:hamburger-menu-broken", url: "/trainer/registerstudent" },
    { name: "Raise Ticket", icon: "solar:hamburger-menu-broken", url: "/trainer/raisedticket" },
    { name: "Request Leave", icon: "iconoir:notes", url: "/trainer/leaverequest" },
    // { name: "Create Assessment", icon: "iconoir:notes", url: "/trainer/asignassessment" },





    // { name: "Payout", icon: "solar:wallet-money-outline", url: "/trainer/payout" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" }
];

export const CoordinatorMenu = [
    { name: "Dashboard", icon: "clarity:home-solid", url: "/coordinator/dashboard" },
    { name: "Student Enquiry", icon: "cuida:user-add-outline", url: "/coordinator/studentenquiry" },
    { name: "T&C List", icon: "iconoir:notes", url: "/coordinator/termandcondition" },
    { name: "Students List", icon: "tdesign:user-list", url: "/coordinator/studentlist" },
    { name: "Moments", icon: "solar:hamburger-menu-broken", url: "/coordinator/momentandattendance" },
    { name: "Trainer Attendance", icon: "fluent:form-28-regular", url: "/coordinator/trainerattendance" },
    { name: "Trainer Assign", icon: "fluent:form-28-regular", url: "/coordinator/trainerassign" },
    { name: "Apartment List", icon: "fluent:form-28-regular", url: "/coordinator/apartmentlist" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/coordinator/raisedticket" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" }
];


export const AdminMenu = [


    {
        name: "Student Master",
        icon: "hugeicons:student",
        subMenu: [
            { name: "Student List", url: "/admin/studentlist" },
            { name: "Moment & Attendance", url: "/admin/momentandattendance" },
            { name: "Enquiry Form", url: "/admin/studentenquiry" },
            { name: "Add Coupon Code", url: "/admin/addcouponcode" },

        ]
    },
    {
        name: "Trainer Master",
        icon: "material-symbols-light:school-outline",
        subMenu: [
            { name: "Trainer List", url: "/admin/trainerlist" },
            { name: "Assign Trainer", url: "/admin/assigntrainer" },
            { name: "Attendance", url: "/admin/trainerattendance" },

        ]
    },
    {
        name: "User Master",
        icon: "mynaui:users-group",
        subMenu: [
            { name: "All User List", url: "/admin/alluserlist" },
            { name: "Role List", url: "/admin/rolelist" },
            { name: "Co-ordinator List", url: "/admin/coordinatorlist" },
            { name: "Zone Head List", url: "/admin/zoneheadlist" },
            { name: "Marketing Executive List", url: "/admin/assignzonetomarketingexecutive" },
            { name: "Subscriber List", url: "/admin/subscriberlist" },
        ]
    },
    { name: "Order Manager", icon: "lsicon:order-outline", url: "/admin/orderlist" },

    { name: "Template", icon: "lsicon:order-outline", url: "/admin/addtemplate" },

    {
        name: "Course & Event",
        icon: "hugeicons:course",
        subMenu: [

            { name: "Add New Courses", url: "/admin/addcourses" },
            { name: "Course List", url: "/admin/courselist" },
            { name: "Event List", url: "/admin/eventlist" },
            { name: "Add Syllabus", url: "/admin/addsyllabus" },
            { name: "Question Bank", url: "/admin/addquestionbank" },
            { name: "Create Assesments", url: "/admin/createassesments" },

        ]
    },
    {
        name: "Apartment Master",
        icon: "ph:building-light",
        subMenu: [
            { name: "Apartment List", url: "/admin/apartmentlist" },
            { name: "Add Edit ApartmentList", url: "/admin/addeditapartmentlist" },
            { name: "Facility List", url: "/admin/facilitylist" },
            { name: "T&C List", url: "/admin/termandcondition" },


        ]
    },
    { name: "School List", icon: "solar:hamburger-menu-broken", url: "/admin/schoollist" },
    { name: "Reports", icon: "oui:nav-reports", url: "/admin/reports" },
    // { name: "Student List", icon: "hugeicons:students", url: "/admin/studentlist" },
    // { name: "Trainer List", icon: "hugeicons:mentoring", url: "/admin/trainerlist" },
    // { name: "Assign Trainer", icon: "hugeicons:mentoring", url: "/admin/assigntrainer" },
    // { name: "Apartment List", icon: "solar:buildings-2-broken", url: "/admin/apartmentlist" },
    // { name: "Co-ordinator List", icon: "fluent:people-list-16-regular", url: "/admin/coordinatorlist" },
    {
        name: "Region",
        icon: "weui:location-outlined",
        subMenu: [
            { name: "City", url: "/admin/city" },
            { name: "State", url: "/admin/state" },
            { name: "Country", url: "/admin/country" },
            { name: "Zone List", url: "/admin/zonelist" },
            { name: "Cluster", url: "/admin/clusterlist" }
        ]
    },
    { name: "school Request", icon: "solar:hamburger-menu-broken", url: "/admin/schoolrequest" },
    {
        name: "Masters",
        icon: "material-symbols:settings-input-component-outline",
        subMenu: [
            { name: "Board", url: "/admin/board" },
            { name: "Medium", url: "/admin/medium" },
            { name: "Grade", url: "/admin/grade" },
            { name: "Section", url: "/admin/section" },
        ]
    },
    {
        name: "LMS",
        icon: "hugeicons:course",
        subMenu: [
            { name: "Add LMS", url: "/admin/addlms" },
            { name: "LMS List", url: "/admin/lmslist" },
            // { name: "Course Type", url: "/admin/addlmscoursetype" },
            { name: "Grades", url: "/admin/addlmsgrade" },
            { name: "Languages", url: "/admin/addlmslanguage" },
            { name: "Boards", url: "/admin/addlmsboard" },
            { name: "Publications", url: "/admin/addlmspublication" },
            { name: "Subject", url: "/admin/addlmssubject" },
            { name: "Tag", url: "/admin/addlmstag" },
            { name: "Document", url: "/admin/document" },
            { name: "Chapters", url: "/admin/addlmschapter" },
            { name: "Topic", url: "/admin/addlmstopic" },
            { name: "Add LMS Threejs ", url: "/admin/addquestionThreejs" },
            { name: "View LMS Threejs", url: "/admin/threejslmslist" },
            { name: "Threejs view", url: "/admin/threejsview" }








        ]
    },
        {
        name: "Activity LMS",
        icon: "carbon:course",
        subMenu: [
            { name: "Adding Course", url: "/admin/activitylms/add" },
            { name: "View Course", url: "/admin/activitylms/view" },
        ]
    },
    {
        name: "AI LMS",
        icon: "mingcute:ai-line",
        subMenu: [
            { name: "Adding Course", url: "/admin/ailms/add" },
            { name: "View Course", url: "/admin/ailms/view" },
        ]
    },
    {
        name: "Ticket",
        icon: "heroicons:ticket",
        subMenu: [

            { name: "TicketList", url: "/admin/ticketlist" },
            { name: "Raise Ticket", url: "/admin/raisedticket" },

        ]
    },





    // { name: "All User List", icon: "stash:people-group-light", url: "/admin/alluserlist" },
    // { name: "Role List", icon: "oui:app-users-roles", url: "/admin/rolelist" },

    // { name: "Course List", icon: "hugeicons:course", url: "/admin/courselist" },
    // { name: "Event List", icon: "carbon:events", url: "/admin/eventlist" },

    // { name: "Facility List", icon: "lsicon:work-order-info-filled", url: "/admin/facilitylist" },
    // { name: "T&C List", icon: "iconoir:notes", url: "/admin/termandcondition" },
    // { name: "Moment", icon: "solar:hamburger-menu-broken", url: "/admin/momentandattendance" },
    // { name: "Student Enquiry", icon: "fluent:form-28-regular", url: "/admin/studentenquiry" },
    // { name: "Trainer Attendance", icon: "fluent:form-28-regular", url: "/admin/trainerattendance" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" }
];


export const marketingExecutiveMenu = [
    // { name: "Facility List", icon: "material-symbols:move-location-outline", url: "/mareketingexcutive/facility" },
    // { name: "T&C List", icon: "iconoir:notes", url: "/mareketingexcutive/newtermandcondition" },
    // { name: "Contact Person", icon: "hugeicons:students", url: "/mareketingexcutive/contactpersonlist" },
    { name: "Apartment List", icon: "hugeicons:students", url: "/mareketingexcutive/apartmentlist" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/mareketingexcutive/raisedticket" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" }
]

export const marketingManagerMenu = [
    // {
    //     name: "T&C List",
    //     icon: "iconoir:notes",
    //     subMenu: [
    //         { name: "New T&C List", url: "/mareketingmanager/newtermandcondition" },
    //         { name: "Onboard T&C List", url: "/mareketingmanager/onboardtermandcondition" },
    //     ]
    // },


    { name: "Add Coupon Code", icon: "cuida:user-add-outline", url: "/mareketingmanager/addcouponcode" },
    { name: "T&C List", icon: "cuida:user-add-outline", url: "/mareketingmanager/termsandcondition" },
    { name: "Add Executive", icon: "cuida:user-add-outline", url: "/mareketingmanager/addexecutive" },
    { name: "Zone List", icon: "hugeicons:user-list", url: "/mareketingmanager/zonelist" },
    { name: "Add Cluster", icon: "hugeicons:user-list", url: "/mareketingmanager/addcluster" },
    { name: "Zonal Coordinator", icon: "hugeicons:user-list", url: "/mareketingmanager/addzonalcoordinator" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/mareketingmanager/raisedticket" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
]


export const zoneManagerMenu = [
    { name: "T&C List", icon: "iconoir:notes", url: "/zonemanager/termandcondition" },
    { name: "Student Enquiry", icon: "fluent:form-28-regular", url: "/zonemanager/enquiryform" },
    { name: "Moment", icon: "solar:hamburger-menu-broken", url: "/zonemanager/momentandattendance" },
    { name: "Tainer Attendance", icon: "solar:hamburger-menu-broken", url: "/zonemanager/trainerattendance" },
    { name: "Coordinator List", icon: "solar:hamburger-menu-broken", url: "/zonemanager/coordinatorlist" },
    { name: "Assign Trainer", icon: "solar:hamburger-menu-broken", url: "/zonemanager/assigntrainer" },
    { name: "Apartment List", icon: "solar:hamburger-menu-broken", url: "/zonemanager/apartmentlist" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/zonemanager/raisedticket" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
]

export const zoneHeadMenu = [
    { name: "Student Enquiry", icon: "iconoir:notes", url: "/zonehead/enquiryform" },
    { name: "Moment", icon: "fluent:form-28-regular", url: "/zonehead/momentandattendance" },
    { name: "Student List", icon: "solar:hamburger-menu-broken", url: "/zonehead/studentlist" },
    { name: "T&C List", icon: "solar:hamburger-menu-broken", url: "/zonehead/termsconditions" },
    { name: "Tainer Attendance", icon: "solar:hamburger-menu-broken", url: "/zonehead/trainerattendance" },
    { name: "Coordinator List", icon: "solar:hamburger-menu-broken", url: "/zonehead/coordinatorlist" },
    { name: "Apartment List", icon: "solar:hamburger-menu-broken", url: "/zonehead/apartmentlist" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/zonehead/raisedticket" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
]

export const zonalcoordinatorMenu = [
    { name: "Add Coupon Code", icon: "iconoir:notes", url: "/zonalcoordinator/addcouponcode" },
    { name: "Apartment List", icon: "iconoir:notes", url: "/zonalcoordinator/addapartment" },
    { name: "Add Payouts & Marketing Ads", icon: "iconoir:notes", url: "/zonalcoordinator/addptm" },
    { name: "Add Term And Condition", icon: "iconoir:notes", url: "/zonalcoordinator/termsandcondition" },
    { name: "Assign Trainer", icon: "iconoir:notes", url: "/zonalcoordinator/assigntrainer" },
    { name: "Trainer Attendance", icon: "iconoir:notes", url: "/zonalcoordinator/trainerattendance" },
    { name: "Apartment List", icon: "iconoir:notes", url: "/zonalcoordinator/apartmentlist" },
    { name: "Cluster List", icon: "iconoir:notes", url: "/zonalcoordinator/clusterlist" },
    // { name: "Assign Zone", icon: "iconoir:notes", url: "/zonalcoordinator/assignzone" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/zonalcoordinator/raisedticket" },
    // { name: "Student Attendance", icon: "iconoir:notes", url: "/zonalcoordinator/checkattendance" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },

]

export const parentcounsellorMenu = [
    { name: "Student Enquiry", icon: "iconoir:notes", url: "/parentcounsellor/studentenquiry" },
    { name: "Share  Courses", icon: "iconoir:notes", url: "/parentcounsellor/sharecourses" },
    { name: "Share  Moments", icon: "iconoir:notes", url: "/parentcounsellor/sharememory" },
    { name: "Student List", icon: "iconoir:notes", url: "/parentcounsellor/studentlist" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/parentcounsellor/raisedticket" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
]

export const HRMenu = [
    // { name: "Trainer List", icon: "iconoir:notes", url: "/humanresources/trainerresume" },
    { name: "Resume Bank", icon: "iconoir:notes", url: "/humanresources/resumebank" },
    { name: "Onboarded Trainers", icon: "iconoir:notes", url: "/humanresources/onboardedtrainers" },
    { name: "Trainer Attendance", icon: "iconoir:notes", url: "/humanresources/trainerattendance" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/humanresources/raisedticket" },
    { name: "Salary Calculate", icon: "iconoir:notes", url: "/humanresources/trainersalarycalculate" },
    { name: "Leave Requested List", icon: "iconoir:notes", url: "/humanresources/leaverequestlist" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },

]

export const SchoolMenu = [
    { name: "Dashbaord", icon: "iconoir:notes", url: "/school/dashbaord" },
    { name: "My Courses", icon: "iconoir:notes", url: "/school/mycourses" },
    { name: "Add Teachers", icon: "iconoir:notes", url: "/school/addteachers" },
    { name: "Explore Courses", icon: "iconoir:notes", url: "/school/explorecourses" },
    // { name: "Skill Box", icon: "iconoir:notes", url: "/school/skillbox" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/school/raisedticket" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
]


export const ProTeacherMenu = [
    { name: "Dashboard", icon: "iconoir:notes", url: "/proteacher/dashbaord" },
    { name: "My Courses", icon: "iconoir:notes", url: "/proteacher/mycourses" },
    { name: "Explore Courses", icon: "iconoir:notes", url: "/proteacher/explorecourses" },
    // { name: "Skill Box", icon: "iconoir:notes", url: "/proteacher/skillbox" },
    { name: "Raise Ticket", icon: "iconoir:notes", url: "/proteacher/raisedticket" },
    { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
]


// export const COOMenu = [
//     { name: "Student List", icon: "iconoir:notes", url: "/coo/studentlist" },
//     { name: "Trainer List", icon: "iconoir:notes", url: "/coo/trainerlist" },
//     { name: "All User List", icon: "iconoir:notes", url: "/coo/alluserlist" },
//     { name: "Coordinator List", icon: "iconoir:notes", url: "/coo/coordinatorlist" },
//     { name: "Zone Head List", icon: "iconoir:notes", url: "/coo/zoneheadlist" },
//     { name: "Order List", icon: "iconoir:notes", url: "/coo/orderlist" },
//     { name: "Course List", icon: "iconoir:notes", url: "/coo/courselist" },
//     { name: "Event List", icon: "iconoir:notes", url: "/coo/eventlist" },
//     { name: "Apartment List", icon: "iconoir:notes", url: "/coo/apartmentlist" },
//     { name: "Reports", icon: "iconoir:notes", url: "/coo/reports" },
//     { name: "Trainer Attendance", icon: "iconoir:notes", url: "/coo/trainerattendance" },
//     { name: "Resume Bank", icon: "iconoir:notes", url: "/coo/resumebank" },
//     { name: "Onboarded Trainer", icon: "iconoir:notes", url: "/coo/acceptedtrainerlist" },
//     { name: "Ticket List", icon: "iconoir:notes", url: "/coo/assignticketList" },
//     { name: "Raise Ticket", icon: "iconoir:notes", url: "/coo/raisedticket" },
//     { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
// ];


export const COOMenu = [
    {
        name: "User Master",
        icon: "mynaui:users-group",
        subMenu: [
            { name: "Student List", url: "/coo/studentlist" },
            { name: "Trainer List", url: "/coo/trainerlist" },
            { name: "All User List", url: "/coo/alluserlist" },
            { name: "Coordinator List", url: "/coo/coordinatorlist" },
            { name: "Zone Head List", url: "/coo/zoneheadlist" },
        ],
    },
    {
        name: "Trainer Management",
        icon: "material-symbols-light:school-outline",
        subMenu: [
            { name: "Trainer Attendance", url: "/coo/trainerattendance" },
            { name: "Resume Bank", url: "/coo/resumebank" },
            { name: "Onboarded Trainers", url: "/coo/onboardedtrainers" },
        ],
    },
    {
        name: "Order & Course",
        icon: "lsicon:order-outline",
        subMenu: [
            { name: "Order List", url: "/coo/orderlist" },
            { name: "Course List", url: "/coo/courselist" },
            { name: "Event List", url: "/coo/eventlist" },
        ],
    },
    {
        name: "Apartment Master",
        icon: "ph:building-light",
        subMenu: [
            { name: "Apartment List", url: "/coo/apartmentlist" },
        ],
    },
    {
        name: "Reports & Analytics",
        icon: "oui:nav-reports",
        subMenu: [
            { name: "Reports", url: "/coo/reports" },
        ],
    },
    {
        name: "Ticket Management",
        icon: "hugeicons:course",
        subMenu: [
            { name: "Ticket List", url: "/coo/assignticketList" },
            { name: "Raise Ticket", url: "/coo/raisedticket" },
        ],
    },
    {
        name: "Logout",
        icon: "ic:sharp-logout",
        url: "/logout",
    },
];



// export const CTOMenu = [
//     { name: "Student List", icon: "iconoir:notes", url: "/cto/studentlist" },
//     { name: "Trainer List", icon: "iconoir:notes", url: "/cto/trainerlist" },
//     { name: "All User List", icon: "iconoir:notes", url: "/cto/alluserlist" },
//     { name: "Coordinator List", icon: "iconoir:notes", url: "/cto/coordinatorlist" },
//     { name: "Zone Head List", icon: "iconoir:notes", url: "/cto/zoneheadlist" },
//     { name: "Order List", icon: "iconoir:notes", url: "/cto/orderlist" },
//     { name: "Course List", icon: "iconoir:notes", url: "/cto/courselist" },
//     { name: "Event List", icon: "iconoir:notes", url: "/cto/eventlist" },
//     { name: "Apartment List", icon: "iconoir:notes", url: "/cto/apartmentlist" },
//     { name: "Ticket List", icon: "iconoir:notes", url: "/cto/assignticketList" },
//     { name: "Raise Ticket", icon: "iconoir:notes", url: "/cto/raisedticket" },
//     { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
// ];
export const CTOMenu = [
    {
        name: "User Master",
        icon: "mynaui:users-group",
        subMenu: [
            { name: "Student List", url: "/cto/studentlist" },
            { name: "Trainer List", url: "/cto/trainerlist" },
            { name: "All User List", url: "/cto/alluserlist" },
            { name: "Coordinator List", url: "/cto/coordinatorlist" },
            { name: "Zone Head List", url: "/cto/zoneheadlist" },
        ],
    },
    {
        name: "Order & Course",
        icon: "lsicon:order-outline",
        subMenu: [
            { name: "Order List", url: "/cto/orderlist" },
            { name: "Course List", url: "/cto/courselist" },
            { name: "Event List", url: "/cto/eventlist" },
        ],
    },
    {
        name: "Apartment Master",
        icon: "ph:building-light",
        subMenu: [
            { name: "Apartment List", url: "/cto/apartmentlist" },
        ],
    },
    {
        name: "Ticket Management",
        icon: "hugeicons:course",
        subMenu: [
            { name: "Ticket List", url: "/cto/assignticketList" },
            { name: "Raise Ticket", url: "/cto/raisedticket" },
        ],
    },
    {
        name: "Logout",
        icon: "ic:sharp-logout",
        url: "/logout",
    },
];



// export const CEOMenu = [
//     { name: "Student List", icon: "iconoir:notes", url: "/ceo/studentlist" },
//     { name: "Trainer List", icon: "iconoir:notes", url: "/ceo/trainerlist" },
//     { name: "All User List", icon: "iconoir:notes", url: "/ceo/alluserlist" },
//     { name: "Coordinator List", icon: "iconoir:notes", url: "/ceo/coordinatorlist" },
//     { name: "Zone Head List", icon: "iconoir:notes", url: "/ceo/zoneheadlist" },
//     { name: "Order List", icon: "iconoir:notes", url: "/ceo/orderlist" },
//     { name: "Course List", icon: "iconoir:notes", url: "/ceo/courselist" },
//     { name: "Event List", icon: "iconoir:notes", url: "/ceo/eventlist" },
//     { name: "Apartment List", icon: "iconoir:notes", url: "/ceo/apartmentlist" },
//     { name: "Reports", icon: "iconoir:notes", url: "/ceo/reports" },
//     { name: "Ticket List", icon: "iconoir:notes", url: "/ceo/assignticketList" },
//     { name: "Raise Ticket", icon: "iconoir:notes", url: "/ceo/raisedticket" },
//     { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },

// ];
export const CEOMenu = [
    {
        name: "User Master",
        icon: "mynaui:users-group",
        subMenu: [
            { name: "Student List", url: "/ceo/studentlist" },
            { name: "Trainer List", url: "/ceo/trainerlist" },
            { name: "All User List", url: "/ceo/alluserlist" },
            { name: "Coordinator List", url: "/ceo/coordinatorlist" },
            { name: "Zone Head List", url: "/ceo/zoneheadlist" },
        ],
    },
    {
        name: "Order & Course",
        icon: "lsicon:order-outline",
        subMenu: [
            { name: "Order List", url: "/ceo/orderlist" },
            { name: "Course List", url: "/ceo/courselist" },
            { name: "Event List", url: "/ceo/eventlist" },
        ],
    },
    {
        name: "Apartment Master",
        icon: "ph:building-light",
        subMenu: [
            { name: "Apartment List", url: "/ceo/apartmentlist" },
        ],
    },
    {
        name: "Reports & Analytics",
        icon: "oui:nav-reports",
        subMenu: [
            { name: "Reports", url: "/ceo/reports" },
        ],
    },
    {
        name: "Ticket Management",
        icon: "hugeicons:course",
        subMenu: [
            { name: "Ticket List", url: "/ceo/assignticketList" },
            { name: "Raise Ticket", url: "/ceo/raisedticket" },
        ],
    },
    {
        name: "Logout",
        icon: "ic:sharp-logout",
        url: "/logout",
    },
];


// export const CAOMenu = [
//     { name: "Student List", icon: "iconoir:notes", url: "/cao/studentlist" },
//     { name: "Trainer List", icon: "iconoir:notes", url: "/cao/trainerlist" },
//     { name: "Order List", icon: "iconoir:notes", url: "/cao/orderlist" },
//     { name: "Course List", icon: "iconoir:notes", url: "/cao/courselist" },
//     { name: "Event List", icon: "iconoir:notes", url: "/cao/eventlist" },
//     { name: "Apartment List", icon: "iconoir:notes", url: "/cao/apartmentlist" },
//     { name: "Trainer Attendance", icon: "iconoir:notes", url: "/cao/trainerattendance" },
//     { name: "Raise Ticket", icon: "iconoir:notes", url: "/cao/raisedticket" },
//     { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
// ];

export const CAOMenu = [
    {
        name: "User Master",
        icon: "mynaui:users-group",
        subMenu: [
            { name: "Student List", url: "/cao/studentlist" },
            { name: "Trainer List", url: "/cao/trainerlist" },
        ],
    },
    {
        name: "Order & Course",
        icon: "lsicon:order-outline",
        subMenu: [
            { name: "Order List", url: "/cao/orderlist" },
            { name: "Course List", url: "/cao/courselist" },
            { name: "Event List", url: "/cao/eventlist" },
        ],
    },
    {
        name: "Apartment Master",
        icon: "ph:building-light",
        subMenu: [
            { name: "Apartment List", url: "/cao/apartmentlist" },
        ],
    },
    {
        name: "Trainer Management",
        icon: "material-symbols-light:school-outline",
        subMenu: [
            { name: "Trainer Attendance", url: "/cao/trainerattendance" },
        ],
    },
    {
        name: "Ticket Management",
        icon: "hugeicons:course",
        subMenu: [
            { name: "Raise Ticket", url: "/cao/raisedticket" },
        ],
    },
    {
        name: "Logout",
        icon: "ic:sharp-logout",
        url: "/logout",
    },
];


// export const CFOMenu = [
//     { name: "Student List", icon: "iconoir:notes", url: "/cfo/studentlist" },
//     { name: "All User List", icon: "iconoir:notes", url: "/cfo/alluserlist" },
//     { name: "Coordinator List", icon: "iconoir:notes", url: "/cfo/coordinatorlist" },
//     { name: "Zone Head List", icon: "iconoir:notes", url: "/cfo/zoneheadlist" },
//     { name: "Order List", icon: "iconoir:notes", url: "/cfo/orderlist" },
//     { name: "Course List", icon: "iconoir:notes", url: "/cfo/courselist" },
//     { name: "Event List", icon: "iconoir:notes", url: "/cfo/eventlist" },
//     { name: "Apartment List", icon: "iconoir:notes", url: "/cfo/apartmentlist" },
//     { name: "Reports", icon: "iconoir:notes", url: "/cfo/reports" },
//     { name: "Raise Ticket", icon: "iconoir:notes", url: "/cfo/raisedticket" },
//     { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
// ];



export const CFOMenu = [
    {
        name: "User Master",
        icon: "mynaui:users-group",
        subMenu: [
            { name: "Student List", url: "/cfo/studentlist" },
            { name: "All User List", url: "/cfo/alluserlist" },
            { name: "Coordinator List", url: "/cfo/coordinatorlist" },
            { name: "Zone Head List", url: "/cfo/zoneheadlist" },
        ],
    },
    {
        name: "Order & Course",
        icon: "lsicon:order-outline",
        subMenu: [
            { name: "Order List", url: "/cfo/orderlist" },
            { name: "Course List", url: "/cfo/courselist" },
            { name: "Event List", url: "/cfo/eventlist" },
        ],
    },
    {
        name: "Apartment Master",
        icon: "ph:building-light",
        subMenu: [
            { name: "Apartment List", url: "/cfo/apartmentlist" },
        ],
    },
    {
        name: "Reports & Analytics",
        icon: "oui:nav-reports",
        subMenu: [
            { name: "Reports", url: "/cfo/reports" },
        ],
    },
    {
        name: "Ticket Management",
        icon: "hugeicons:course",
        subMenu: [
            { name: "Raise Ticket", url: "/cfo/raisedticket" },
        ],
    },
    {
        name: "Logout",
        icon: "ic:sharp-logout",
        url: "/logout",
    },
];



// export const CMOMenu = [
//     { name: "Order List", icon: "iconoir:notes", url: "/cmo/orderlist" },
//     { name: "Course List", icon: "iconoir:notes", url: "/cmo/courselist" },
//     { name: "Event List", icon: "iconoir:notes", url: "/cmo/eventlist" },
//     { name: "Apartment List", icon: "iconoir:notes", url: "/cmo/apartmentlist" },
//     { name: "Reports", icon: "iconoir:notes", url: "/cmo/reports" },
//     { name: "Raise Ticket", icon: "iconoir:notes", url: "/cmo/raisedticket" },
//     { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
// ];

export const CMOMenu = [
    {
        name: "Order & Course",
        icon: "lsicon:order-outline",
        subMenu: [
            { name: "Order List", url: "/cmo/orderlist" },
            { name: "Course List", url: "/cmo/courselist" },
            { name: "Event List", url: "/cmo/eventlist" },
        ],
    },
    {
        name: "Apartment Master",
        icon: "ph:building-light",
        subMenu: [
            { name: "Apartment List", url: "/cmo/apartmentlist" },
        ],
    },
    {
        name: "Reports & Analytics",
        icon: "oui:nav-reports",
        subMenu: [
            { name: "Reports", url: "/cmo/reports" },
        ],
    },
    {
        name: "Ticket Management",
        icon: "hugeicons:course",
        subMenu: [
            { name: "Raise Ticket", url: "/cmo/raisedticket" },
        ],
    },
    {
        name: "Logout",
        icon: "ic:sharp-logout",
        url: "/logout",
    },
];



// export const SMEMenu = [
//     { name: "Student List", icon: "iconoir:notes", url: "/sme/studentlist" },
//     { name: "Trainer List", icon: "iconoir:notes", url: "/sme/trainerlist" },
//     { name: "Course List", icon: "iconoir:notes", url: "/sme/courselist" },
//     { name: "Event List", icon: "iconoir:notes", url: "/sme/eventlist" },
//     { name: "Raise Ticket", icon: "iconoir:notes", url: "/sme/raisedticket" },
//     { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
// ];

export const SMEMenu = [
    {
        name: "User Master",
        icon: "mynaui:users-group",
        subMenu: [
            { name: "Student List", url: "/sme/studentlist" },
            { name: "Trainer List", url: "/sme/trainerlist" },
        ],
    },
    {
        name: "Course & Events",
        icon: "hugeicons:course",
        subMenu: [
            { name: "Course List", url: "/sme/courselist" },
            { name: "Event List", url: "/sme/eventlist" },
        ],
    },
    {
        name: "Ticket Management",
        icon: "iconoir:chat-lines",
        subMenu: [
            { name: "Raise Ticket", url: "/sme/raisedticket" },
        ],
    },
    {
        name: "Logout",
        icon: "ic:sharp-logout",
        url: "/logout",
    },
];



// export const LAMMenu = [
//     { name: "Student List", icon: "iconoir:notes", url: "/lam/studentlist" },
//     { name: "Trainer List", icon: "iconoir:notes", url: "/lam/trainerlist" },
//     { name: "Order List", icon: "iconoir:notes", url: "/lam/orderlist" },
//     { name: "Course List", icon: "iconoir:notes", url: "/lam/courselist" },
//     { name: "Event List", icon: "iconoir:notes", url: "/lam/eventlist" },
//     { name: "Apartment List", icon: "iconoir:notes", url: "/lam/apartmentlist" },
//     { name: "Trainer Attendance", icon: "iconoir:notes", url: "/lam/trainerattendance" },
//     { name: "Ticket List", icon: "iconoir:notes", url: "/lam/assignticketList" },
//     { name: "Raise Ticket", icon: "iconoir:notes", url: "/lam/raisedticket" },
//     { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
// ];

export const LAMMenu = [
    {
        name: "User Master",
        icon: "mynaui:users-group",
        subMenu: [
            { name: "Student List", url: "/lam/studentlist" },
            { name: "Trainer List", url: "/lam/trainerlist" },
        ],
    },
    {
        name: "Trainer Management",
        icon: "material-symbols-light:school-outline",
        subMenu: [
            { name: "Trainer Attendance", url: "/lam/trainerattendance" },
        ],
    },
    {
        name: "Order & Course",
        icon: "lsicon:order-outline",
        subMenu: [
            { name: "Order List", url: "/lam/orderlist" },
            { name: "Course List", url: "/lam/courselist" },
            { name: "Event List", url: "/lam/eventlist" },
        ],
    },
    {
        name: "Apartment Master",
        icon: "ph:building-light",
        subMenu: [
            { name: "Apartment List", url: "/lam/apartmentlist" },
        ],
    },
    {
        name: "Ticket Management",
        icon: "hugeicons:course",
        subMenu: [
            { name: "Ticket List", url: "/lam/assignticketList" },
            { name: "Raise Ticket", url: "/lam/raisedticket" },
        ],
    },
    {
        name: "Logout",
        icon: "ic:sharp-logout",
        url: "/logout",
    },
];



// export const CHROMenu = [

//     { name: "Trainer Attendance", icon: "iconoir:notes", url: "/chro/trainerattendance" },
//     { name: "Resume Bank", icon: "iconoir:notes", url: "/chro/trainerlist" },
//     { name: "Onboarded Trainer", icon: "iconoir:notes", url: "/chro/acceptedtrainerlist" },
//     { name: "HR List", icon: "iconoir:notes", url: "/chro/hrlist" },
//     { name: "Raise Ticket", icon: "iconoir:notes", url: "/chro/raisedticket" },
//     { name: "Logout", icon: "ic:sharp-logout", url: "/logout" },
// ];

export const CHROMenu = [
    {
        name: "Trainer Management",
        icon: "mynaui:users-group",
        subMenu: [
            { name: "Trainer Attendance", url: "/chro/trainerattendance" },
            { name: "Resume Bank", url: "/chro/resumebank" },
            { name: "Onboarded Trainers", url: "/chro/onboardedtrainers" },
        ],
    },
    {
        name: "HR Operations",
        icon: "lsicon:order-outline",
        subMenu: [
            { name: "HR List", url: "/chro/hrlist" },
        ],
    },
    {
        name: "Ticket Management",
        icon: "iconoir:chat-lines",
        subMenu: [
            { name: "Raise Ticket", url: "/chro/raisedticket" },
        ],
    },
    {
        name: "Logout",
        icon: "ic:sharp-logout",
        url: "/logout",
    },
];








